var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Staat__Icn/40px/Legende/Staat",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,27 L32,29 L28,29 L28,27 L32,27 Z M26,27 L26,29 L24,29 L24,27 L26,27 Z M22,27 L22,29 L19,29 L19,27 L22,27 Z M17,27 L17,29 L14,29 L14,27 L17,27 Z M12,27 L12,29 L8,29 L8,27 L12,27 Z M28,15 L28,25 L12,25 L12,15 L28,15 Z M32,22 L32,25 L30,25 L30,22 L32,22 Z M10,23 L10,25 L8,25 L8,23 L10,23 Z M26,17 L14,17 L14,23 L26,23 L26,17 Z M10,18 L10,21 L8,21 L8,18 L10,18 Z M32,17 L32,20 L30,20 L30,17 L32,17 Z M10,14 L10,16 L8,16 L8,14 L10,14 Z M32,11 L32,15 L30,15 L30,11 L32,11 Z M12,11 L12,13 L8,13 L8,11 L12,11 Z M18,11 L18,13 L14,13 L14,11 L18,11 Z M23,11 L23,13 L20,13 L20,11 L23,11 Z M28,11 L28,13 L25,13 L25,11 L28,11 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Staat__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaat);
export default __webpack_public_path__ + "static/media/Staat.5516daf67724a493c455bc02adbca3b4.svg";
export { ForwardRef as ReactComponent };